import React from 'react'

function CheckCircleIcon() {
  return (
    <svg
      width="79"
      height="78"
      viewBox="0 0 79 78"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="39.5" cy="39" r="39" fill="#FA7C00" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M52.157 30.6063C52.6505 31.0382 52.7006 31.7884 52.2687 32.282L35.6437 51.282C35.4273 51.5293 35.118 51.6759 34.7895 51.6869C34.461 51.6978 34.1427 51.5721 33.9103 51.3397L26.7853 44.2147C26.3216 43.751 26.3216 42.9991 26.7853 42.5353C27.2491 42.0716 28.0009 42.0716 28.4647 42.5353L34.6922 48.7628L50.4813 30.718C50.9132 30.2245 51.6634 30.1745 52.157 30.6063Z"
        fill="white"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default CheckCircleIcon
